module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI1MjAiIGhlaWdodD0iMzQwIiB2aWV3Qm94PSIwIDAgMjYwIDE3MCI+PHBhdGggZmlsbD0iIzAwNTNBNSIgZD0iTTAgMGgyNjB2MTcwSDB6Ii8+PGcgZmlsbD0iI0ZGQ0UwMCI+PHBhdGggZD0iTTgwIDBoNTB2MTcwSDgweiIvPjxwYXRoIGQ9Ik0wIDYwaDI2MHY1MEgweiIvPjwvZz48ZyBmaWxsPSIjRDIxMDM0Ij48cGF0aCBkPSJNOTUgMGgyMHYxNzBIOTV6Ii8+PHBhdGggZD0iTTAgNzVoMjYwdjIwSDB6Ii8+PC9nPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/flags/ala.svg
// module id = +dB7
// module chunks = 0